import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { Button, Input, Table, Row, Col, Label } from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import Seccion from "../../Seccion";

// Catalogo de zonas de reparto. Una zona se da de baja, no se borra: los
// clientes que ya la tienen la conservan.
function ListadoZonas() {
  const { user } = useContext(AuthContext);
  const URL_ZONAS = process.env.REACT_APP_URL_ZONAS;
  const auth = () => ({ headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } });

  const [zonas, setZonas] = useState([]);
  const [nombre, setNombre] = useState("");
  const [editando, setEditando] = useState(null);
  const [textoEdit, setTextoEdit] = useState("");
  const [guardando, setGuardando] = useState(false);

  useEffect(() => {
    axios.get(URL_ZONAS, auth()).then((r) => setZonas(r.data)).catch((e) => console.log(e));
  }, [URL_ZONAS]);

  const avisaError = (error) =>
    Swal.fire({ icon: "error", title: "No se guardo", text: error.response?.data?.message || "Intenta de nuevo" });

  async function crear(e) {
    e.preventDefault();
    setGuardando(true);
    try {
      const { data } = await axios.post(URL_ZONAS, { name: nombre }, auth());
      setZonas((prev) => [...prev, data].sort((a, b) => a.name.localeCompare(b.name)));
      setNombre("");
    } catch (error) {
      avisaError(error);
    }
    setGuardando(false);
  }

  async function actualiza(zona, cambios) {
    try {
      const { data } = await axios.patch(`${URL_ZONAS}/${zona._id}`, cambios, auth());
      setZonas((prev) => prev.map((z) => (z._id === zona._id ? data : z)));
      setEditando(null);
    } catch (error) {
      avisaError(error);
    }
  }

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_departamentos ? (
        <div className="container">
          <Button size="sm" href="/MenuVentas" className="btn btn-danger" id="botonListado">
            Regresar
          </Button>
          <h3 align="center">Zonas</h3>
          {user.zonas_create ? (
          <Seccion titulo="Nueva zona" icono="fas fa-map-marker-alt" ayuda="Las zonas se asignan a cada cliente y sirven para filtrar las ventas">
            <form onSubmit={crear}>
              <Row className="align-items-end">
                <Col md={6}>
                  <Label>Nombre</Label>
                  <Input value={nombre} required maxLength={60} placeholder="Polanco" onChange={(e) => setNombre(e.target.value)} />
                </Col>
                <Col md={2}>
                  <Button type="submit" color="success" disabled={guardando || !nombre.trim()}>Guardar</Button>
                </Col>
              </Row>
            </form>
          </Seccion>
          ) : null}
          <Table size="sm" striped borderless>
            <thead>
              <tr>
                <th>Zona</th>
                <th>Estatus</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {zonas.map((z) => (
                <tr key={z._id}>
                  <td>
                    {editando === z._id ? (
                      <Input bsSize="sm" value={textoEdit} maxLength={60} onChange={(e) => setTextoEdit(e.target.value)} />
                    ) : (
                      z.name
                    )}
                  </td>
                  <td>{z.is_active === "Si" ? "Activa" : "Inactiva"}</td>
                  <td>
                    {editando === z._id ? (
                      <>
                        <Button size="sm" color="success" onClick={() => actualiza(z, { name: textoEdit })}>Guardar</Button>{" "}
                        <Button size="sm" color="secondary" onClick={() => setEditando(null)}>Cancelar</Button>
                      </>
                    ) : user.zonas_create ? (
                      <>
                        <Button size="sm" color="info" title="Editar" onClick={() => { setEditando(z._id); setTextoEdit(z.name); }}>
                          <i className="far fa-edit" />
                        </Button>{" "}
                        <Button size="sm" color={z.is_active === "Si" ? "danger" : "primary"} title={z.is_active === "Si" ? "Dar de baja" : "Reactivar"}
                          onClick={() => actualiza(z, { is_active: z.is_active === "Si" ? "No" : "Si" })}>
                          <i className={z.is_active === "Si" ? "fas fa-ban" : "fas fa-undo"} />
                        </Button>
                      </>
                    ) : null}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      ) : undefined}
    </>
  );
}

export default ListadoZonas;
